<template>
  <div
    v-if="quote && Object.keys(quote).length"
    class="text-center"
  >
    <!-- MONTHLY -->
    <div
      v-if="monthly"
      @click="$emit('open-more-info')"
    >
      <div v-if="qd.calcMonthly > 0 && !isEversureBroker">
        <p
          class="font-weight-bold mb-0"
          :class="{
            'headline': !size,
            'display-2': size === 'large',
            'title': size === 'small',
          }"
          v-html="calcMonthly"
        /><p class="caption mb-0">
          per month
        </p>
        <results-price-cashback
          v-if="cashback"
          :cashback="cashback"
          :cashback-unit="qd.cashbackUnit"
        />
      </div>
      <div v-else>
        <div class="caption text-center">
          <div class="info--text font-weight-medium">
            Instalments
          </div>
          <div class="font-weight-bold">
            Check with provider
          </div>
        </div>
        <results-price-cashback
          v-if="cashback"
          :cashback="cashback"
          :cashback-unit="qd.cashbackUnit"
        />
      </div>
    </div>
    <!-- ANNUAL -->
    <div
      v-else
      class="text-center"
      @click="$emit('open-more-info')"
    >
      <p
        class="font-weight-bold mb-0"
        :class="{
          'headline': !size,
          'display-2': size === 'large',
          'title': size === 'small',
        }"
        v-html="calcAnnual"
      />
      <p
        v-if="qd.calcAnnual !== parseFloat(qd.annualPremium)"
        class="info--text mb-0"
        :class="{
          'fs-11': !size || size === 'large',
          'fs-10': size === 'small',
        }"
      >
        <em>
          &pound;{{ qd.annualPremium.toFixed(2) }} excluding optional extras
        </em>
      </p>
      <p
        v-else
        class="caption mb-0"
      >
        per year
      </p>
      <results-price-cashback
        v-if="cashback"
        :cashback="cashback"
        :cashback-unit="qd.cashbackUnit"
      />
    </div>
  </div>
</template>

<script>
import ResultsPriceCashback from '@/components/car/Results/ResultsPriceCashback.vue';

// For large price (more than 1000) we need to change font-size so it fits in the table cell
const smallest4DigitNumber = 1000;

export default {
  name: 'results-price',
  components: {
    ResultsPriceCashback,
  },
  inject: ['helpers'],
  props: {
    quote: {
      required: false,
      type: Object,
      default: () => {},
    },
    monthly: {
      required: false,
      type: Boolean,
      default: false,
    },
    size: {
      required: false,
      type: String,
      default: '',
    },
    cashback: {
      type: Number,
      default: null,
    },
  },
  data () {
    return {
      smallest4DigitNumber,
    };
  },
  computed: {
    qd () {
      return this.quote.details[0];
    },
    priceClasses () {
      const classes = [];
      if (!this.size || this.size === 'small') classes.push('subtitle-2');
      if (this.size === 'large') classes.push('headline');
      return classes.join(' ');
    },
    calcMonthly () {
      return this.helpers.getPriceTemplate(this.qd.calcMonthly, this.priceClasses);
    },
    calcAnnual () {
      return this.helpers.getPriceTemplate(this.qd.calcAnnual, this.priceClasses);
    },
    monthlyPriceClassName () {
      if (this.qd.calcMonthly >= this.smallest4DigitNumber) {
        return 'fs-16';
      }

      if (this.size === 'large') {
        return 'headline';
      }

      return 'title';
    },
    isEversureBroker () {
      // Requirement from business for specific insurer
      return this.qd.brokerFullName === 'Eversure' && this.qd.deposit === 0;
    },
  },
  methods: {
    showPriceDescription () {
      this.$emit('open-drawer-details', ['details-description', 'estimatedPrice']);
    },
  },
};
</script>
